import { DecodeHtml } from '../../utils/decodeHtml'

const DepartmentSection = ({ college }) => {
  return (
    <div className='flex flex-col gap-5 p-4 md:px-10'>
        {
            DecodeHtml({html: college?.subheading?.markup})
        }


      {college?.collegeLabs?.items?.length > 0 &&
        college?.collegeLabs?.items?.map(lab => {
          lab = lab?.content?.properties
          return (
            <div key={lab?.label} className='flex flex-col gap-5'>
              <h1 className='text-3xl font-bold '>{lab?.label}</h1>
              {DecodeHtml({ html: lab?.accordionContent?.markup })}
            </div>
          )
        })}
    </div>
  )
}

export default DepartmentSection
